import {AbstractEvent} from "@/modules/base/events";
import {TransferListing} from "@/modules/transfer-market/entity";

export class AfterTransferListingCreatedEvent extends AbstractEvent {
  constructor(
    public listing: TransferListing,
  ) {
    super();
  }
}